
<div class="policy-snapshot-container">
  @for (field of fields; track field) {
    <app-desktop-list-view
      [data]="field"
      [attr.id]="field.name"
      [class.highlighted]="(selectedSection$ | async) === field.name"
      >
    </app-desktop-list-view>
  }
</div>

